import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=2592d64b&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=2592d64b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2592d64b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2592d64b')) {
      api.createRecord('2592d64b', component.options)
    } else {
      api.reload('2592d64b', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=2592d64b&scoped=true&", function () {
      api.rerender('2592d64b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YvQfb82U5jMh/JS/comp/GuestBox.vue"
export default component.exports